module.exports = {
      id: "add-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#add-usage",
      toString: function () {
        return this.url;
      }
    }